import { useState, memo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Transition } from "@headlessui/react";
import { Tooltip } from "flowbite-react";
import { IconosMenu } from './IconosMenu.js';
import { classNames } from "../tools/ClassNames";

const Tab = ({ x, activeTab, recibirId, top, id, setAncho }) => {
    const [show, setShow] = useState(false);
    const location = useLocation();

    const verRuta = (ruta) => {
        if (ruta[0].href === "/campus/reporte_morosidad") {
            location.pathname = "/campus/reporte_descuento_reducido";
            location.search = "/campus/reporte_morosidad";
        }
    };

    if (x.access) {
        // Cambia la lógica para verificar si el tab está activo
        x.current = activeTab.includes(x.name);

        return (
            <div
                className='relative'
                onMouseOut={() => { setShow(false); !x.subMenu && setAncho("4") }}
            >
                {/* Menu contenedor */}
                <Tooltip content={x.name} placement={x.subMenu ? 'top-start' : 'right'} animation='duration-1000'>
                    <Link
                        key={x.name}
                        onMouseOver={x.subMenu ? () => { setShow(true); setAncho("110"); } : () => { setShow(false); setAncho("110") }}
                        onMouseOut={x.subMenu ? () => { setShow(false); setAncho("4") } : () => { setShow(false); setAncho("4") }}
                        onClick={() => {
                            setShow(current => !current);
                            if (window.innerWidth > 1500 && (window.location.pathname === x.href)) {
                                window.location.reload();
                            }
                        }}
                        to={x.href}
                        className={classNames(
                            x.current ? 'bg-gray-900 text-white' : 'text-gray-400 hover:bg-gray-700',
                            'flex-shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg'
                        )}
                    >
                        <IconosMenu
                            classes='h-6 w-6'
                            nameIcono={x.icon} />
                    </Link>
                </Tooltip>

                {x.subMenu ? (
                    <Transition show={show}>
                        <div
                            onMouseOver={() => { x.subMenu && setShow(true); setAncho("110"); }}
                            onMouseOut={() => { x.subMenu && setShow(false); setAncho("4"); }}
                            onClick={() => verRuta(x.subMenu)}
                            className={`bg-primarioMira rounded-lg w-96 p-3 -top-1 left-14 absolute elementFadeIn shadow shadow-white`}
                        >
                            <style>
                                {
                                    `.g {
                                        width: auto;
                                        position: fixed;
                                    }`
                                }
                            </style>

                            {x.subMenu.map((y) => {
                                // Cambia la lógica para verificar si el sub-tab está activo
                                if (y.access) {
                                    y.current = activeTab.includes(y.name);
                                    return (
                                        <Link
                                            key={y.name}
                                            onMouseOver={() => { setShow(true); }}
                                            onMouseOut={() => { setAncho("4") }}
                                            to={y.href}
                                            className={classNames(
                                                y.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                'pl-8 flex items-center px-2 py-2 text-base font-medium rounded-md'
                                            )}
                                        >
                                            <IconosMenu
                                                nameIcono={y.icon}
                                                onMouseOut={() => { setAncho("4") }}
                                                classes={y.current
                                                    ? 'text-gray-300 mr-4 flex-shrink-0 h-6 w-6'
                                                    : 'text-gray-400 group-hover:text-gray-300 mr-4 flex-shrink-0 h-6 w-6'}
                                            />
                                            {y.name}
                                        </Link>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                    </Transition>
                ) : null}
            </div>
        );
    } else {
        return null;
    }
}

export default memo(Tab);